<template>
  <div class="navigation" id="side-nav-content">
    <div class="navigation-content">

      <!-- <div class="search">
        <form action="#" method="GET" id="navSearch">
          <div class="form-group">
            <label for="search" class="sr-only">Recherche</label>
            <input type="text" class="form-control" id="search" name="search" placeholder="Recherche" />
          </div>
          <button type="submit">
            <span class="sr-only">Recherche</span>
            <i class="fa fa-search" aria-hidden="true"></i>
          </button>
        </form>

        <ul class="nav flex-column d-none d-md-block d-xl-none">
          <li class="nav-item">
            <a href="#" title="Recherche" class="nav-link">
              <i class="fa fa-search" aria-hidden="true"></i>
              <span>Recherche</span>
            </a>
          </li>
        </ul>
      </div> -->

      <ul class="nav flex-column">

        <!--<li class="navigation-section" id="Main">
          Content
          <div class="edgar"></div>
        </li>-->

        <!-- <li class="nav-item">
          <router-link :to="{name: 'Layout'}" title="Home" class="nav-link">
            <i class="fa fa-home" aria-hidden="true"></i>
            <span>Home</span>
          </router-link>
        </li> -->

        <!-- <li class="nav-item">
          <a href="#" title="Contact" class="nav-link">
            <i class="fa fa-map-marker" aria-hidden="true"></i>
            <span>Contact</span>
          </a>
        </li> -->

        <!-- MODULES -->
        <li class="nav-item" v-for="rte in sortedRoutes" v-bind:key="rte.name" v-if="isAuthorize(rte.meta.roles)">
          <router-link :to="{name: rte.name}" :title="rte.meta.text" class="nav-link">
            <i class="fa-fw" :class="rte.meta.iconClass" aria-hidden="true"></i>
            <span>{{$t(rte.meta.title)}}</span>
            <span v-if="rte.meta.badgeReady && rte.meta.badge" class="badge">{{rte.meta.badgeNumber}}</span>
            <span v-if="!rte.meta.badgeReady && rte.meta.badge" class="badge badge-spinner">
              <i class="fas fa-circle-notch fa-spin"></i>
            </span>
          </router-link>
        </li>

        <!-- CART -->
        <!-- <li class="navigation-section">
          Cart
          <div class="cargo"></div>
        </li>

        <li class="nav-item">
          <a href="#" title="Products" class="nav-link">
            <i class="fa fa-tags" aria-hidden="true"></i>
            <span>Products</span>
            <span class="badge">4 000</span>
          </a>
        </li> -->

        <!-- GENERAL -->
        <!-- <li class="navigation-section">
          General
        </li>

        <li class="nav-item">
          <a href="#" title="Medias" class="nav-link">
            <i class="fa fa-file-image-o" aria-hidden="true"></i>
            <span>Medias</span>
            <span class="badge">383</span>
          </a>
        </li> 

        <li class="nav-item">
          <a href="/admin/user/" title="Users" class="nav-link">
            <i class="fa fa-users" aria-hidden="true"></i>
            <span>Users</span>
            <span class="badge">5</span>
          </a>
        </li>

        <li class="nav-item">
          <a href="#" title="Settings" class="nav-link">
            <i class="fa fa-cog" aria-hidden="true"></i>
            <span>Settings</span>
          </a>
        </li>-->
      </ul>
      <div class="bottom">
        <a href="http://www.volcan.design/" title="volcan.design" target="_blank" class="volcan">
        <span class="icon-logo-single-color"></span>
        <span class="icon-volcan"></span>
        </a>

        <div class="copyright">
          Volcan - All Rights Reserved
        </div>

        <!--<div class="version">
          Version 180829
        </div>-->
      </div>

    </div>
  </div>
</template>
<script>
import vueready from '@s/Layout/Assets/js/admin.min.js'
import apitools from '@mixins/apitools.js'
import compte from '@mixins/compte.js'
export default {
  name: 'Nav',
  mixins: [apitools, compte],
  data() {
    return {
      navModuleRoutes: []
    }
  },
  computed: {
    sortedRoutes() {
      return _.sortBy(this.$menuItems.filter(it => it.meta.show), [
        o => o.meta.order,
        o => _.deburr(o.meta.title)
      ])
    }
  },
  mounted() {
    this.$menuItems = this.$root.$children[0].moduleRoutes

    vueready()

    this.closeMobileMenuOnClick()
    this.getBadges()
  },
  methods: {
    closeMobileMenuOnClick() {
      $(window).click(() => {
        this.navClick()
      })

      $('#button-mobile-nav').click(event => {
        event.stopPropagation()
      })
    },
    navClick() {
      var sidenavcontent = $('#side-nav-content')
      var buttonmobilemav = $('#button-mobile-nav')
      if (sidenavcontent.hasClass('open') && buttonmobilemav.hasClass('open')) {
        sidenavcontent.removeClass('open')
        buttonmobilemav.removeClass('open')
      }
    }
  }
}
</script>

<style>
.navigation .navigation-content .nav .nav-item .nav-link .badge.badge-spinner {
  padding: 2px 0 !important;
  background-color: unset !important;
  border: none !important;
}
.navigation .navigation-content .nav .nav-item .nav-link .badge-spinner > i {
  padding: 0 !important;
  margin: 0 !important;
  background-color: unset !important;
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// shared/layout/Nav.vue